import './styles.css';
import { render } from 'preact';
import Phaser from 'phaser';
import { startSubscriber } from './bridge/subscribe';
import { App } from './ui/App';
import { audio } from './audio-singleton';
import { BootScene } from './game/BootScene';
import { MenuScene } from './game/MenuScene';
import { PlayScene } from './game/PlayScene';
import { ResultScene } from './game/ResultScene';
import { createUiPrefs } from './lib/ui-prefs';
import { setSharedUiPrefs } from './lib/shared-prefs';
import { SOUND_UI_ENABLED } from './lib/features';

// INVARIANT (spec §3.1): subscribe → mount Preact → start Phaser.
// This ordering ensures the very first `scene:enter:BOOT` event has a registered subscriber.
startSubscriber();

// Spec §3.3: construct exactly ONE UiPrefs before render() + new Phaser.Game(...).
const uiPrefs = createUiPrefs(window.localStorage);
setSharedUiPrefs(uiPrefs);

const uiRoot = document.getElementById('ui');
if (!uiRoot) throw new Error('#ui element missing in index.html');
uiRoot.style.cssText = 'position:fixed; inset:0; pointer-events:none;';
render(<App uiPrefs={uiPrefs} />, uiRoot);

// Initialize audio module (Howls preload; no playback until first user gesture).
// Skipped while SOUND_UI_ENABLED is off: play() is a no-op pre-init, so the
// silent stub .ogg files are never fetched.
if (SOUND_UI_ENABLED) audio().init();

const gameRoot = document.getElementById('game');
if (!gameRoot) throw new Error('#game element missing in index.html');

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: gameRoot,
  width: window.innerWidth,
  height: window.innerHeight,
  backgroundColor: '#0d2e1a',
  pixelArt: true,
  scene: [BootScene, MenuScene, PlayScene, ResultScene],
  scale: { mode: Phaser.Scale.RESIZE, autoCenter: Phaser.Scale.CENTER_BOTH },
  audio: { noAudio: true },
});

declare global {
  interface Window {
    __napiGame__?: Phaser.Game;
    __napiTestToday__?: string;
  }
}
window.__napiGame__ = game;
